import { ACCOUNTS_NEWS } from '../constants/actionTypes';

interface ILoadingReducer {
    type: string
}

const loadingReducer = (state = false, action : ILoadingReducer) => {
    switch (action.type) {
        case ACCOUNTS_NEWS.LOAD:
            return true;
        case ACCOUNTS_NEWS.LOAD_SUCCESS:
            return false;
        case ACCOUNTS_NEWS.LOAD_FAIL:
            return false;
        
        default:
            return state;
    }
};

export default loadingReducer;
